/** Returns whether the payload is '' */
export function isEmptyString(payload) {
    return payload === '';
}
